import React from 'react';
import ServicoCard from './ServicoCard';
import { ServicoItem } from './services.types';

interface Props {
  servicos: ServicoItem[];
  onClickContratar?: (key: ServicoItem['key']) => void;
}

const ServicosGrid: React.FC<Props> = ({ servicos, onClickContratar }) => {
  return (
    <section className="py-16 md:py-24 bg-color-surface">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {servicos.map((s) => (
            <ServicoCard key={s.key} servico={s} onClickContratar={onClickContratar} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicosGrid;
